import { t } from "@/i18n-js/instance";
import {
  annualDiscountPercentage,
  planAmountWithCurrencySuffix,
} from "@/react/helpers/planHelpers";
import type { Plan } from "@/react/types/Plan";

import { LineItem } from "./LineItem";

interface AnnualSavingsProps {
  selectedPlan: Plan;
}

export const AnnualSavings = ({ selectedPlan }: AnnualSavingsProps) => (
  <LineItem
    description={t("pricing_plans.plan_settings.plan_summary.annual_savings", {
      percentage: annualDiscountPercentage(selectedPlan),
    })}
    value={`-${planAmountWithCurrencySuffix(selectedPlan.annual_discount_amount_with_currency || "", selectedPlan.currency)}`}
    valueProps={{ color: "text-green-success" }}
  />
);
